import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "text-wrap" }
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mt-25" }
const _hoisted_13 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createVNode(_component_router_link, {
              to: "/transferts/liste-transferts",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour ")
              ])),
              _: 1
            })
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-center fw-bold" }, "Transfert Magasin", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Magasin source :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.transfert?.magasin1?.nomMagasin || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Magasin destination :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.transfert?.magasin2?.nomMagasin ||  'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Motif :", -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.transfert?.motif || 'N/A'), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "fw-bold mb-1" }, "MontantTotal :", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.transfert?.montantTotal || 'N/A'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "bg-primary" }, "ProduitsCondtionnés"),
                  _createElementVNode("th", { class: "bg-primary" }, "Qté transférées"),
                  _createElementVNode("th", { class: "bg-primary" }, "PrixUnitaire")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transfert?.transfertprocondis, (transfert, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(transfert?.produitcondi?.nomProCond || 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(transfert?.qtite || 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(transfert?.prixUnitaire || 'N/A'), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}